import moment from "moment-timezone";

export const SYSTEMS_ALARMS_POLLING_INTERVAL = 10 * 1000;
export const AXIOS_TIMEOUT = { timeout: 15 * 1000 };
export const EXPORT_FILE_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

export const GAUGE_NEEDLE_COLOR = "var(--color-medium-grey)";
export const CHECKBOX_STATES = { UNCHECKED: 0, INDETERMINATE: 1, CHECKED: 2 };

export const PRIMARY_COLOR = "#128370";
export const PRIMARY_RED_COLOR = "#e4001c";
export const ORANGE_COLOR = "#ff9e19";
export const PRIMARY_BLACK = "#000000";
export const PRIMARY_WHITE = "#FFFFFF";
export const MEDIUM_GREY = "#969696";
export const BLUE_COLOR = "#1d74b4";
export const PALE_TEAL_COLOR = "#e2f7f5";
export const GREEN_COLOR = "#30a530";
export const ORANGE_COLOR_CHART = "#ef8529";
export const PINK_COLOR = "#FC2D72";
export const LIGHT_BLUE_COLOR = "#00A9E0";

export const REPORT_CUSTOM_MAX_DAYS = 90;
export const ANALYTICS_MAX_DAYS_DURATION = 180;

export const LOCAL_TIME_ZONE = moment.tz.guess();
export const ADD_BASELINE_DATE_FORMAT = `YYYY-MM-DD HH:mm:ss`;
export const LOCAL_TZ_CODE = moment.tz(LOCAL_TIME_ZONE).format("z");
export const DATE_FORMAT = "DD MMM YYYY";
export const DATE_TIME_FORMAT = `${DATE_FORMAT}, HH:mm`; //24hrs format
export const DATE_TIME_SECONDS_FORMAT = `${DATE_FORMAT}, HH:mm:ss`;
export const TIME_FORMAT = "HH:mm";
export const DATE_FORMAT_SMALL = "dd MMM yyyy";
export const DATE_TIME_FORMAT_SMALL = `${DATE_FORMAT_SMALL}, HH:mm:ss`; //24hrs format
export const DATE_FORMAT_WITH_BITWISEOR = `${DATE_FORMAT} | HH:mm:ss`;

export const INPUT_MINIMUM = 3;
export const INPUT_MAXIMUM = 30;
export const INPUT_ADDRESS_MAXIMUM = 100;
export const INPUT_SIZE_MAXIMUM = 10;
export const INPUT_DESIGN_MAXIMUM = 10;
export const WIDGET_TITLE_INPUT_MAXIMUM = 20;

export const NOTIFICATION_DEFAULT_DURATION = 3000;

export const HOUR_IN_SECONDS = 3600;
export const MIN_IN_SECONDS = 60;
export const INPUT_DEBOUNCE_DURATION = 250;

export const ROUND_OFF_NUMBER = 4;
export const HOURS_IN_A_DAY = 24;
export const MINUTES_IN_AN_HOUR = 60;
export const MS_IN_A_SECOND = 1000;

export const TAG_TYPES = {
  NORMALIZED: "N",
  STANDARD: "T",
  SET_POINT: "S",
  FORMULA: "F"
};
